export default __webpack_public_path__ + "static/media/425.93f49320.jpg";